import { H4, Image, LI, P, UL } from "../../../AbstractElements";
import { Comments, Hits, MarkJecno, SingleBlogHeading, SingleBlogParagraph1, SingleBlogParagraph2 } from "../../../Constant";
import { dynamicImage } from "../../../Service/DynamicImage";

export const SingleBlogData = () => {
  return (
    <div className="blog-box blog-details">
      <Image className="img-fluid w-100" src={dynamicImage("blog/blog-single.jpg")} alt="blog-main" />
      <div className="blog-details">
        <UL className="blog-social d-flex flex-row simple-list d-block">
          <LI className="rounded-0">25 July 2023</LI>
          <LI>
            <i className="icofont icofont-user" />
            {MarkJecno}
          </LI>
          <LI className="digits">
            <i className="icofont icofont-thumbs-up" /> 02<span>{Hits}</span>
          </LI>
          <LI className="digits">
            <i className="icofont icofont-ui-chat" /> {Comments}
          </LI>
        </UL>
        <H4>{SingleBlogHeading}</H4>
        <div className="single-blog-content-top">
          <P>{SingleBlogParagraph1}</P>
          <P>{SingleBlogParagraph2}</P>
        </div>
      </div>
    </div>
  );
};
